// Vendor Billing v1.0 — the shared invoice status chip (status-chip ladder
// vocabulary; status uses ONLY the four status tokens, gold is never state).

import { StatusBadge } from "@/design-system/components/ui";
import type { VendorInvoiceStatus } from "@/api/portfolioAdmin/types";
import { INVOICE_STATUS_LABEL, invoiceStatusTone } from "./vendorBillingFormat";

export function InvoiceStatusBadge({ status }: { status: VendorInvoiceStatus }) {
  return (
    <StatusBadge
      tone={invoiceStatusTone(status)}
      struck={status === "void"}
      data-testid={`invoice-status-${status}`}
    >
      {INVOICE_STATUS_LABEL[status]}
    </StatusBadge>
  );
}
